import { IConstructorOptions } from "../../../Utilities";
import { GetToday } from "../../Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";
import { DataEntityBase } from "./Base/DataEntityBase";
import { Models } from "./Base/Models";


export enum RecapEntryType {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",

    unknown = "unknown"
}

export const RecapEntryTypeOrder = (() => {
    let retVal: RecapEntryType[] = [];
    const keys = Object.keys(RecapEntryType) as Array<keyof typeof RecapEntryType>;

    for (let key of keys) {
        if (key === RecapEntryType.unknown)
            return retVal;
        retVal.push(RecapEntryType[key as keyof typeof RecapEntryType]);
    }
    return retVal;
})();


export enum RecapStatus {
    NotReady = "NotReady",
    NotStarted = "NotStarted",
    Inprogress = "Incomplete",
    Complete = "Complete"
}




export enum RecapEntryProperties {
    entryType = '_recapEntryType',
    entry = '_entry',
    selectedMagicMomentIds = '_selectedMagicMomentIds',
    selectedAccomplishmentIds = '_selectedAccomplishmentIds',
    startDate = '_startDate',
    endDate = '_endDate',
    status = '_status',
    childRecapIds = '_childRecapIds',
    score = '_score'
}



export class RecapEntry extends DataEntityBase {

    public static get TypeName() { return Models.RecapEntry; }

    public static OptionsFromKey = (key: string) => {
        let data = RecapEntry.DataFromKey(key);
        let options =
            DataEntityBase.ConstructorOptionsBuilder(DataEntityBase.OptionsFromId(RecapEntry.CreateId(key)))
                .addProp(RecapEntryProperties.entryType, data.type)
                .addProp(RecapEntryProperties.endDate, data.date);

        return options;
    }

    public static DataFromKey = (key: string) => {
        let [type, dateStr] = key.split(' - ');
        return { type: type as RecapEntryType, date: new Date(dateStr) };
    }
    public static CreateKey = (date: Date, type: RecapEntryType) => `${type} - ${date.toISOString()}`;
    public static CreateId(key: string) {
        return DataEntityBase.CreateId(RecapEntry.TypeName, key)
    };

    public static Create({ watcher, options }: { watcher?: BasicEntityWatcher, options?: IConstructorOptions }) {
        var retVal = new RecapEntry(options);
        watcher?.RegisterEntity(retVal);
        return retVal;
    }



    private constructor(options?: IConstructorOptions) {

        super(
            {
                typename: RecapEntry.TypeName,
                serializationProperties: RecapEntryProperties,
                dateProperties: RecapEntry.dateProperties,
                jsonProperties: RecapEntry.jsonProperties
            },);


        this.CompleteConstruction(options);
    }

    private static dateProperties: string[] = [
        RecapEntryProperties.startDate,
        RecapEntryProperties.endDate
    ];


    private static jsonProperties: string[] = [
    ];

    public get DateRange(): { start: Date, end: Date } {
        return { start: this._startDate, end: this._endDate };
    }
    public set DateRange(value: { start: Date, end: Date }) {
        this._startDate = value.start;
        this._endDate = value.end;
        this.key = RecapEntry.CreateKey(this._endDate, this.entryType);
        this.FireChanged('DateRange');
    }
    private _startDate: Date = GetToday();
    private _endDate: Date = GetToday();

    public get entryType(): RecapEntryType { return this[RecapEntryProperties.entryType]; }
    public set entryType(value: RecapEntryType) {
        this.key = RecapEntry.CreateKey(this._endDate, value);
        this.UpdateAndFire(RecapEntryProperties.entryType, value);
    }
    [RecapEntryProperties.entryType] = RecapEntryType.unknown;

    public get entry(): string { return this[RecapEntryProperties.entry]; }
    public set entry(value: string) { this.UpdateAndFire(RecapEntryProperties.entry, value); }
    [RecapEntryProperties.entry] = "";

    public get selectedMagicMomentIds(): string[] { return this[RecapEntryProperties.selectedMagicMomentIds]; }
    public set selectedMagicMomentIds(value: string[]) { this.UpdateAndFire(RecapEntryProperties.selectedMagicMomentIds, value); }
    [RecapEntryProperties.selectedMagicMomentIds] = []

    public get selectedAccomplishmentIds(): string[] { return this[RecapEntryProperties.selectedAccomplishmentIds]; }
    public set selectedAccomplishmentIds(value: string[]) { this.UpdateAndFire(RecapEntryProperties.selectedAccomplishmentIds, value); }
    [RecapEntryProperties.selectedAccomplishmentIds] = []

    public get status(): RecapStatus { return this[RecapEntryProperties.status]; }
    public set status(value: RecapStatus) { this.UpdateAndFire(RecapEntryProperties.status, value); }
    [RecapEntryProperties.status] = RecapStatus.NotReady;

    public get childRecapIds(): string[] { return this[RecapEntryProperties.childRecapIds]; }
    public set childRecapIds(value: string[]) {
        this.UpdateAndFire(RecapEntryProperties.childRecapIds, value);
    }
    [RecapEntryProperties.childRecapIds] = [];

    public get score(): number { return this[RecapEntryProperties.score]; }
    public set score(value: number) {
        this.UpdateAndFire(RecapEntryProperties.score, value);
    }
    [RecapEntryProperties.score] = 0;


}